angular.module('FmsApp').factory('PermissionEvaluatorService', function() {
  return {
    isReadWrite: function(access) {
      return access === 'read-edit';
    }
  };
});
